import classNames from 'classnames';
import React, { useState } from 'react';
import { Outlet } from 'react-router';
import { useQuery } from '@apollo/client';
import { SessionActions } from '../../account/sessionSlice';
import { gql } from '../../graphql/generated';
import { LinkForceNewTabContext } from '../../utils/router/Link';
import { getThemeClassName } from '../../utils/themeHelpers';
import { useAppDispatch } from '../redux/useAppSelector';
import * as styles from './ExtensionApp.module.scss';

const EXTENSION_SESSION_QUERY = gql(/** @complexity 6 */ `
  query extensionSession {
    currentSession {
      ...startSession_session
    }
  }
`);

const ExtensionApp = () => {
  const dispatch = useAppDispatch();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const [theme] = useState<'dark' | 'light'>(() =>
    new URLSearchParams(window.location.search).get('theme') === 'dark'
      ? 'dark'
      : 'light',
  );

  useQuery(EXTENSION_SESSION_QUERY, {
    onCompleted(data) {
      dispatch(SessionActions.startSession(data.currentSession));
      setIsAuthenticated(true);
    },
  });

  return (
    <LinkForceNewTabContext.Provider value>
      <div
        className={classNames(
          styles.container,
          getThemeClassName(theme === 'dark'),
        )}
      >
        {isAuthenticated && <Outlet />}
      </div>
    </LinkForceNewTabContext.Provider>
  );
};

export default ExtensionApp;
